import BlockData from '../../../models/BlockData';
import BlockType from '../../../models/BlockType';
import BlockFooter from '../../../components/Blocks/BlockFooter/BlockFooter';
import BlockHeader from '../../../components/Blocks/Headers/BlockHeader/BlockHeader';
import BlockImage from '../../../components/Blocks/BlockImage/BlockImage';
import BlockImageAndText from '../../../components/Blocks/BlockImageAndText/BlockImageAndText';
import BlockMap from '../../../components/Blocks/BlockMap/BlockMap';
import BlockText from '../../../components/Blocks/BlockText/BlockText';
import BlockTextList from '../../../components/Blocks/BlockTextList/BlockTextList';
import BlockTextWithBackground from '../../../components/Blocks/BlockTextWithBackground/BlockTextWithBackground';
import BlockTitle from '../../../components/Blocks/BlockTitle/BlockTitle';
import BlockMenuList from '../../../components/Blocks/BlockMenuList/BlockMenuList';
import BlockButton from '../../../components/Blocks/BlockButton/BlockButton';
import BlockHtml from '../../../components/Blocks/BlockHtml/BlockHtml';
import BlockCard from '../../../components/Blocks/BlockCard/BlockCard';
import BlockCardCentered from '../../../components/Blocks/BlockCardCentered/BlockCardCentered';
import BlockHeaderWithLogo from '../../../components/Blocks/Headers/BlockHeaderWithLogo/BlockHeaderWithLogo';
import BlockTitleTextButton from '../../../components/Blocks/BlockTitleTextButton/BlockTitleTextButton';
import BlockHeaderLogoMenu from '../../../components/Blocks/Headers/BlockHeaderLogoMenu/BlockHeaderLogoMenu';
import BlockButtonList from '../../../components/Blocks/BlockButtonList/BlockButtonList';
import BlockCarouselWithPureJs from '../../../components/Blocks/BlockCarousel/BlockCarouselWithPureJs';
import BlockImageList from '../../../components/Blocks/BlockImageList/BlockImageList';
import BlockTable from '../../../components/Blocks/BlockTable/BlockTable';
import BlockCenteredImage from '../../../components/Blocks/BlockCenteredImage/BlockCenteredImage';
import BlockFullBleedImage from '../../../components/Blocks/BlockFullBleedImage/BlockFullBleedImage';
import BlockLinedTitle from '../../../components/Blocks/BlockLinedTitle/BlockLinedTitle';
import BlockiFrame from '../../../components/Blocks/BlockiFrame/BlockiFrame';
import BlockSNS from '../../../components/Blocks/BlockSNS/BlockSNS';
import BlockAnimationBlock from '../../../components/Blocks/BlockAnimationBlocks/BlockAnimationBlock';
import BlockContact from '../../../components/Blocks/BlockContact/BlockContact';
import BlockVideo from '../../../components/Blocks/BlockVideo/BlockVideo';
import BlockAnimationWithImageDescription from '../../../components/Blocks/BlockAnimationWithImageDescription/BlockAnimationWithImageDescription';
import BlockMenuListWithColumns from '../../../components/Blocks/BlockMenuListWithColumns/BlockMenuListWithColumns';
import BlockMenuListWithEqualSpace from '../../../components/Blocks/BlockMenuListWithEqualSpace/BlockMenuListWithEqualSpace';
import BlockHtmlSafe from '../../../components/Blocks/BlockHtmlSafe/BlockHtmlSafe';
import BlockiFrameSafe from '../../../components/Blocks/BlockiFrameSafe/BlockiFrameSafe';
import BlockiFrameServices from '../../../components/Blocks/BlockiFrameServices/BlockiFrameServices';
import BlockMenuListFixedMax2 from '../../../components/Blocks/BlockMenuListFixedMax2/BlockMenuListFixedMax2';
import BlockMenuListFixedMax3 from '../../../components/Blocks/BlockMenuListFixedMax3/BlockMenuListFixedMax3';
import BlockMenuListFixedMobile2 from '../../../components/Blocks/BlockMenuListFixedMobile2/BlockMenuListFixedMobile2';
import BlockMenuListEqualMobile2 from '../../../components/Blocks/BlockMenuListEqualMobile2/BlockMenuListEqualMobile2';
import BlockMenuListEqualMax2 from '../../../components/Blocks/BlockMenuListEqualMax2/BlockMenuListEqualMax2';
import BlockMenuListEqualMax3 from '../../../components/Blocks/BlockMenuListEqualMax3/BlockMenuListEqualMax3';

interface Props {
  blockData: BlockData | null
  handleDataChange: (data: BlockData) => void
}

const Index = (props: Props) => {
  const { blockData, handleDataChange } = props;
  if (blockData == null) {
    return <div />;
  }
  switch (blockData.type) {
    case BlockType.HEADER:
    case BlockType.HEADER_FREE:
      return (
        <BlockHeader data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.HEADER_WITH_LOGO:
    case BlockType.HEADER_WITH_LOGO_FREE:
      return (
        <BlockHeaderWithLogo data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.HEADER_LOGO_MENU:
    case BlockType.HEADER_LOGO_MENU_FREE:
      return (
        <BlockHeaderLogoMenu data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.TITLE:
      return (
        <BlockTitle data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.IMAGE:
      return (
        <BlockImage data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.TXT_BACKGROUND:
    case BlockType.TXT_BACKGROUND_TALL:
      return (
        <BlockTextWithBackground data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.IMAGE_TEXT:
      return (
        <BlockImageAndText data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.MENU_LIST_3:
      return (
        <BlockMenuList data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.MAP:
      return (
        <BlockMap data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.TEXT:
      return (
        <BlockText data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.TEXT_LIST:
      return (
        <BlockTextList data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.BUTTON:
      return (
        <BlockButton data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.HTML:
      return (
        <BlockHtml data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.HTML_SAFE:
      return (
        <BlockHtmlSafe data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.CARD_LEFT:
      return (
        <BlockCard data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.CARD_RIGHT:
      return (
        <BlockCard data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.CARD_LEFT_CENTERED:
      return (
        <BlockCardCentered data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.CARD_RIGHT_CENTERED:
      return (
        <BlockCardCentered data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.TITLE_TXT_BUTTON:
    case BlockType.TITLE_TXT_BUTTON_TALL:
      return (
        <BlockTitleTextButton data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.BUTTON_LIST:
      return (
        <BlockButtonList data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.CAROUSEL:
    case BlockType.CAROUSEL_TALL:
    case BlockType.CAROUSEL_FIXED:
    case BlockType.CAROUSEL_FIXED_TALL:
      return (
        <BlockCarouselWithPureJs data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.IMAGE_LIST:
      return (
        <BlockImageList data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.TABLE:
      return (
        <BlockTable data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.TABLE_BOTTOM_BORDER:
      return (
        <BlockTable data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.TABLE_NO_BORDER:
      return (
        <BlockTable data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.CENTERED_IMAGE:
      return (
        <BlockCenteredImage data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.FULL_BLEED_IMAGE:
      return (
        <BlockFullBleedImage data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.FULL_BLEED_CARD_LEFT_CENTERED:
    case BlockType.FULL_BLEED_CARD_RIGHT_CENTERED:
      return (
        <BlockCardCentered data={blockData} isFullBleed isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.LINED_TITLE:
      return (
        <BlockLinedTitle data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.I_FRAME:
      return (
        <BlockiFrame data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.I_FRAME_SAFE:
      return (
        <BlockiFrameSafe data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.I_FRAME_SERVICES:
      return (
        <BlockiFrameServices data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.SNS:
      return (
        <BlockSNS data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.ANIMATION_COMPONENT:
      return (
        <BlockAnimationBlock data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.ANIMATION_WITH_DESCRIPTION_COMPONENT:
      return (
        <BlockAnimationWithImageDescription data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.CONTACT:
      return (
        <BlockContact data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.FOOTER:
    case BlockType.FOOTER_FREE:
      return (
        <BlockFooter data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.VIDEO:
      return (
        <BlockVideo data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} />
      );
    case BlockType.BLOCK_MENU_LIST_WITH_COLUMNS:
      return (
        <BlockMenuListWithColumns data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.BLOCK_MENU_LIST_WITH_EQUAL_SPACE:
      return (
        <BlockMenuListWithEqualSpace data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.BLOCK_MENU_LIST_FIXED_MAX_2:
      return (
        <BlockMenuListFixedMax2 data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.BLOCK_MENU_LIST_FIXED_MAX_3:
      return (
        <BlockMenuListFixedMax3 data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.BLOCK_MENU_LIST_FIXED_MOBILE_2:
      return (
        <BlockMenuListFixedMobile2 data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.BLOCK_MENU_LIST_EQUAL_MOBILE_2:
      return (
        <BlockMenuListEqualMobile2 data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.BLOCK_MENU_LIST_EQUAL_MAX_2:
      return (
        <BlockMenuListEqualMax2 data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    case BlockType.BLOCK_MENU_LIST_EQUAL_MAX_3:
      return (
        <BlockMenuListEqualMax3 data={blockData} isEditing isTemplate editHandler={(_id, data) => { handleDataChange({ ...blockData, data }); }} blockData={[]} />
      );
    default:
      return (
        <div />
      );
  }
};

export default Index;
